<template>
<div>

    <b-button
        class="sub-interaction-tile__button"
        :class="subInteraction.disabled ? 'sub-interaction-tile__button--disabled' : ''"
        :variant="subInteraction.variant"
        @click="handleClick(subInteraction)"
    >
        <div class="mb-3" :class="subInteraction.disabled ? 'shaded-fill-black--disabled' : 'shaded-fill-white'">
            <simple-svg
                :src="subInteraction.icon"
                height="90px"
                width="90px"
            />
        </div>
        <div class="sub-interaction-tile__text d-flex justify-content-center">
            <div :class="subInteraction.disabled ? `color-${subInteraction.variant}` : ''">{{ $t(subInteraction.labels[0].text) }}</div>
            <div v-if="filled" class="ml-1">
                <img src="@/assets/ui/interaction-finish.svg" height="20px" width="20px" />
            </div>
        </div>
    </b-button>

</div>
</template>
<script>
import { INTERACTION_STATUS } from '@/constants/interaction'

export default {
    name: 'subInteractionTile',
    props: {
        subInteraction: {
            type: Object
        }
    },
    computed: {
        filled() {
            return this.subInteraction.status === INTERACTION_STATUS.FILLED
        }
    },
    methods: {
        handleClick(subInteraction) {
            if(!this.subInteraction.disabled) {
                this.$emit('select', subInteraction)
            }
        }
    },
}
</script>
<style lang="scss">
.sub-interaction-tile__button {
    height: 155px;
    width: 155px;
    border-radius: 20px;
    &--disabled {
        background: $base_grey-1 !important;
        border-color: $base_grey-1 !important;
        cursor: default !important;
    }

    @media screen and (max-width: 360px) {
        height: 140px;
        width: 140px;
    }
}

.sub-interaction-tile__text {
    font-size: 0.8em;
    font-weight: 600;

    @media screen and (max-width: 360px) {
        font-size: 0.7em;
    }
}
</style>
